import { Reveal } from "../common/Reveal";
import { EmailCapture } from "../common/EmailCapture";

export const GuestList = () => (
    <section data-testid="guest-list-section" className="bg-pink text-ink py-24 md:py-32">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10 text-left">
            <Reveal>
                <p className="font-manrope text-xs md:text-sm font-bold tracking-[0.35em] uppercase mb-6">
                    10 — The Guest List
                </p>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="font-oswald uppercase leading-[0.85] tracking-tight text-[13vw] md:text-[8rem]">
                    Get On The<br />Guest List.
                </h2>
            </Reveal>
            <Reveal delay={0.16}>
                <p className="mt-6 text-base md:text-lg font-semibold max-w-md">
                    New flavors. New drops. Special events. Good times.
                </p>
            </Reveal>
            <Reveal delay={0.22} className="mt-10">
                <EmailCapture source="guest_list" invertButton testid="guest-list" />
            </Reveal>
        </div>
    </section>
);
